module.exports = __webpack_public_path__ + "img/1186217-15-1.88ef558f.png";